import * as React from 'react';

const Copy = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.3334 0.833313H3.33335C2.41669 0.833313 1.66669 1.58331 1.66669 2.49998V14.1666H3.33335V2.49998H13.3334V0.833313ZM15.8334 4.16665H6.66669C5.75002 4.16665 5.00002 4.91665 5.00002 5.83331V17.5C5.00002 18.4166 5.75002 19.1666 6.66669 19.1666H15.8334C16.75 19.1666 17.5 18.4166 17.5 17.5V5.83331C17.5 4.91665 16.75 4.16665 15.8334 4.16665ZM15.8334 17.5H6.66669V5.83331H15.8334V17.5Z" fill="currentColor"/>
  </svg>
);

export default Copy;
